import { MessageType } from '@interface/common';


export const HINT: MessageType = `hint`;
export const INFO: MessageType = `info`;
export const SUCCESS: MessageType = `success`;
export const WARNING: MessageType = `warning`;
export const ERROR: MessageType = `error`;
